"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const entity_store_1 = require("./entity-store");
class BackingStore extends entity_store_1.EntityStore {
    constructor(classType) {
        super();
        this.classType = classType;
        this.isLoading = false;
    }
}
// A much simpler version of EntityStore that can act as though it's an array
class EntityList {
    constructor(classType, arr = []) {
        this.store = new BackingStore(this.classType);
        this.classType = classType;
        this.store.addAll(arr);
    }
    get(id) {
        return this.store.get(id);
    }
    remove(id) {
        return this.store.remove(id);
    }
    clear() {
        this.store.clear();
    }
    add(entity) {
        return this.store.add(entity);
    }
    addAll(entities) {
        return this.store.addAll(entities);
    }
    concat(entities) {
        return new EntityList(this.classType, [...this, ...entities]);
    }
    get length() {
        return this.store.size;
    }
    get arr() {
        return this.store.values;
    }
    // tslint:disable-next-line
    [Symbol.iterator]() {
        return this.store.iter();
    }
    sort(compare) {
        this.store.sort(compare);
    }
    map(cb) {
        return this.arr.map(cb);
    }
    filter(cb) {
        return this.arr.filter(cb);
    }
}
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EntityList.prototype, "clear", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], EntityList.prototype, "add", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], EntityList.prototype, "addAll", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], EntityList.prototype, "sort", null);
exports.EntityList = EntityList;
exports.default = EntityList;
//# sourceMappingURL=entity-list.js.map